// @flow

import { decodeObject } from "../../shared/utils/decode";
import { InternalOnlyError } from "../../shared/utils/errors";
import { initializeDatePicker } from "./initializeDatePicker";

const bindDatePicker = (
  hiddenInputElement: HTMLInputElement,
  inputElement: HTMLInputElement,
  clearButtonElement: ?HTMLElement,
  calendarButtonElement: ?HTMLElement,
  shouldHideClearButton: boolean,
  startCalendarInput: ?HTMLElement,
  endCalendarInput: ?HTMLElement
) => {
  const datePicker = initializeDatePicker(inputElement, {
    onSelect: (datePickerProps) => {
      const { date } = datePickerProps;
      // eslint-disable-next-line no-param-reassign
      hiddenInputElement.value = date ? date.toISOString().split("T")[0] : "";

      if (!shouldHideClearButton && date) {
        clearButtonElement?.classList.remove("hidden");
      } else {
        clearButtonElement?.classList.add("hidden");
      }
    },
  });

  if (hiddenInputElement.value) {
    datePicker.selectDate(hiddenInputElement.value);
  }

  if (clearButtonElement) {
    clearButtonElement.addEventListener("click", () => datePicker.clear());

    if (shouldHideClearButton || datePicker.selectedDates.length <= 0) {
      clearButtonElement.classList.add("hidden");
    }
  }

  calendarButtonElement?.addEventListener("click", () => inputElement.focus());

  const updateCalendarMinMax = (event: Event, type: string) => {
    const { target } = event;

    if (target instanceof HTMLInputElement) {
      const datePickerString = datePicker[type] ? datePicker[type].toString() : null;
      const targetString = target.value ? new Date(target.value).toString() : null;

      if (datePickerString !== targetString) {
        datePicker.update({ [type]: target.value || false });
      }
    }
  };

  startCalendarInput?.addEventListener("change", (event: Event) => updateCalendarMinMax(event, "minDate"));
  endCalendarInput?.addEventListener("change", (event: Event) => updateCalendarMinMax(event, "maxDate"));
};

const initializeDatePickerContainers = () => {
  document.querySelectorAll(".date-picker-input-container").forEach((container) => {
    const {
      inputId,
      inputHideClearButton,
      inputMinDateCalendarId,
      inputMaxDateCalendarId,
      inputErrors,
      inputDisabled,
    } = container.dataset;

    const hiddenInputElement = document.getElementById(`${inputId}`);
    const inputElement = document.getElementById(`${inputId}_display`);
    const clearButton = container.querySelector(".date-picker-input__close-button");
    const calendarButton = container.querySelector(".date-picker-input__button");

    const minDateCalendarInput = document.getElementById(inputMinDateCalendarId);
    const maxDateCalendarInput = document.getElementById(inputMaxDateCalendarId);

    if (inputDisabled) {
      const isDisabled = decodeObject(inputDisabled);
      if (isDisabled) {
        if (hiddenInputElement instanceof HTMLInputElement) {
          hiddenInputElement.disabled = true;
        }
        if (inputElement instanceof HTMLInputElement) {
          inputElement.disabled = true;
        }
        container.classList.add("is-disabled");
        return;
      }
    }

    if (!(hiddenInputElement instanceof HTMLInputElement) || !(inputElement instanceof HTMLInputElement)) {
      throw new InternalOnlyError("Calendar input not found!");
    }

    bindDatePicker(
      hiddenInputElement,
      inputElement,
      clearButton,
      calendarButton,
      inputHideClearButton === "True",
      minDateCalendarInput,
      maxDateCalendarInput
    );

    const errors: Array<string> = decodeObject(inputErrors);
    errors.forEach((error: string) => {
      const errorElement = document.createElement("p");

      errorElement.textContent = error;
      errorElement.classList.add("help", "is-danger", "is-size-6", "mb-2");

      container.appendChild(errorElement);
    });
  });
};

window.addEventListener("load", initializeDatePickerContainers);
